import type { InjectionKey } from 'vue';

export type CollapseKey = string | number;

export type CollapseValue = CollapseKey | CollapseKey[] | null;

export type CollapseItemInstance = {
	itemKey: CollapseKey;
	setActive: (next: boolean) => void;
};

export type CollapseContext = {
	isCollapseParent: true;
	animationDuration: number;
	isMultiple: boolean;
	addItem: (item: CollapseItemInstance) => void;
	removeItem: (item: CollapseItemInstance) => void;
	deactivateAll: () => void;
	toggleItem: (item: CollapseItemInstance) => void;
};

export const collapseContextKey: InjectionKey<CollapseContext> =
	Symbol('collapseContext');
